import { render } from "./redirection-signature.vue?vue&type=template&id=eb8235e6"
import script from "./redirection-signature.vue?vue&type=script&lang=js"
export * from "./redirection-signature.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__